(() => {
  const text = window.galleryExplorerStrings || {};
  const key = 'dupingdao-gallery-browse';
  const currentPath = location.pathname;
  const isCollection = currentPath.includes('/collections/') && !document.querySelector('.gallery-edition-grid');
  const isProduct = currentPath.includes('/products/');
  if (!isCollection && !isProduct) return;

  const readSnapshot = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(key) || 'null');
      return value && Date.now() - value.savedAt < 3600000 ? value : null;
    } catch {
      return null;
    }
  };
  const relativeUrl = (value) => {
    const url = new URL(value, location.origin);
    return url.pathname + url.search;
  };
  const cardLink = (item) => item.querySelector('.card__information a[id^="CardLink-"]');
  const cards = () => [...document.querySelectorAll('#ProductGridContainer #product-grid > li.grid__item')]
    .filter((item) => cardLink(item));
  const cardData = (item) => {
    const link = cardLink(item);
    const image = item.querySelector('.card__media img');
    const price = item.querySelector('.card-information .price__container');
    return {
      url: relativeUrl(link.href),
      title: link.textContent.trim(),
      image: image?.currentSrc || image?.src || '',
      price: price?.innerText.trim() || '',
      status: item.querySelector('.gallery-sale-status')?.textContent.trim() || ''
    };
  };
  const snapshot = (activeUrl) => {
    const value = {
      listUrl: location.pathname + location.search,
      scrollY: window.scrollY,
      pagesLoaded: Math.max(1, Number(new URLSearchParams(location.search).get('page')) || 1),
      activeUrl,
      items: cards().map(cardData),
      savedAt: Date.now()
    };
    sessionStorage.setItem(key, JSON.stringify(value));
    history.replaceState({ ...history.state, galleryBrowse: value.savedAt }, '');
  };
  if (isProduct) {
    const saved = readSnapshot();
    if (!saved) return;
    const current = relativeUrl(location.href);
    const index = saved.items.findIndex((item) => item.url === current);
    if (index < 0) return;
    const main = document.querySelector('#MainContent');
    const nav = document.createElement('nav');
    nav.className = 'gallery-explorer-detail-nav page-width';
    nav.setAttribute('aria-label', text.browse || '');
    const back = document.createElement('a');
    back.href = saved.listUrl + '#gallery-return';
    back.innerHTML = '<span aria-hidden="true" style="display:block;width:1.4rem;height:1.4rem;border-right:1px solid currentColor;border-bottom:1px solid currentColor;transform:rotate(135deg)"></span>';
    back.setAttribute('aria-label', text.back || 'Retour aux résultats');
    back.style.display = 'inline-flex';
    back.style.alignItems = 'center';
    back.style.justifyContent = 'center';
    back.style.width = '4.4rem';
    back.style.minHeight = '4.4rem';
    back.style.fontSize = '4rem';
    back.style.fontWeight = '300';
    back.style.lineHeight = '1';
    back.style.textDecoration = 'none';
    nav.append(back);
    main?.prepend(nav);
    return;
  }

  const saveBeforeDetails = (link) => {
    const item = link.closest('li.grid__item');
    if (item) snapshot(relativeUrl(link.href));
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('#ProductGridContainer #product-grid li.grid__item a[href*="/products/"]');
    if (link) {
      saveBeforeDetails(link);
      return;
    }
    const media = event.target.closest('#ProductGridContainer #product-grid li.grid__item .card__media');
    const item = media?.closest('li.grid__item');
    const detail = item && cardLink(item);
    if (!detail) return;
    event.preventDefault();
    snapshot(relativeUrl(detail.href));
    location.assign(detail.href);
  });

  const saved = readSnapshot();
  const restoring = location.hash === '#gallery-return'
    || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
  if (restoring && saved && saved.listUrl === location.pathname + location.search) {
    if (location.hash === '#gallery-return') history.replaceState(history.state, '', saved.listUrl);
    requestAnimationFrame(() => window.scrollTo({ top: saved.scrollY, behavior: 'instant' }));
  }
})();
